// ============================================================================
// InactiveAccountCard — the one card a deactivated account sees (migration 218)
// ============================================================================
// Pure presenter: InactiveAccountScreen wraps it in the normal Header and
// supplies Sign Out. The copy is Design Constitution Q39 verbatim; styling is
// the existing card and record-page button tokens until conformance converts
// them.
// ============================================================================
import {S} from '../lib/styles.js';
import {recordSecondaryButton} from './recordPageControls.jsx';

type InactiveAccountCardProps = {
  onSignOut: () => void;
};

export default function InactiveAccountCard({onSignOut}: InactiveAccountCardProps) {
  return (
    <div data-inactive-account-card="1" role="status" style={{...S.card, padding: '20px 18px'}}>
      <h1 style={{fontSize: 18, fontWeight: 700, margin: '0 0 16px', color: 'var(--ink)'}}>
        Your account is inactive — ask an admin
      </h1>
      <button type="button" data-inactive-account-sign-out="1" onClick={onSignOut} style={recordSecondaryButton}>
        Sign Out
      </button>
    </div>
  );
}
